import { render, staticRenderFns } from "./aracalanara.vue?vue&type=template&id=5ff4b71c&"
import script from "./aracalanara.vue?vue&type=script&lang=js&"
export * from "./aracalanara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports